<template>
  <div id="banner" style="background-color: white">
    <img :src="isamnet" style="width: 100%" />
    <div class="main-wrapper">
      <a
        class="closebutton"
        @click="close()"
        v-if="creative.preview_type === CONSTANT.ENUM_PREVIEW_TYPE.INTERSTITIAL"
      ></a>
      <div
        id="main-container"
        :style="`width: ${creative.width}px;height: ${creative.height}px;`"
      >
        <a
          v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
          :href="creative.landing_page"
          target="_blank"
        >
          <img class="main-img" :src="creative.image_url" />
        </a>
        <div
          v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.HTML"
          :style="
            `width: ${creative.width}px;height: ${
              creative.height
            }px;position:absolute;z-index:10;`
          "
          @click="openLandingPage"
        ></div>
        <iframe
          v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.HTML"
          :src="creative.html_url"
          scrolling="no"
          frameborder="0"
          allowfullscreen="true"
          :style="
            `border: none !important; overflow: hidden !important; display: block; background-color: black !important; width: ${
              creative.width
            }px !important; height: ${creative.height}px !important;`
          "
        />
      </div>
    </div>
    <img
      :src="
        setBgImg(
          'https://cdn.aralego.net/rich_media/assets/banner/bg2.png',
          creative.preview_device
        )
      "
      style="width: 100%"
    />
    <img
      :src="
        setBgImg(
          'https://cdn.aralego.net/rich_media/assets/banner/bg3.png',
          creative.preview_device
        )
      "
      style="width: 100%"
    />
  </div>
</template>

<script>
import mixPreview from '@/components/mixins/preview.js';
import mixOutstream from '@/components/mixins/outstream.js';
import mixMobile from '@/components/mixins/mobile.js';
import mixYoutubePlayer from '@/components/mixins/youtubePlayer.js';
import FacebookPlayer from '@/components/mixins/facebookPlayer.js';
export default {
  data() {
    return {
      player: null,
    };
  },
  computed: {
    position() {
      let layoutObj = this.setLayout(
        this.creative.vertical_align,
        this.creative.vertical_padding,
        this.creative.horizontal_align,
        this.creative.horizontal_padding
      );
      layoutObj.position = 'absolute';
      layoutObj['z-index'] = 1000;
      return layoutObj;
    },
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = 'https://cdn.aralego.net/rich_media/assets';
      if (domain === 'prism.amnet.tw') {
        isAmnet += '/amnet/bg2.png';
      } else {
        isAmnet += '/banner/bg1.png';
      }
      this.setBgImg(isAmnet, this.creative.preview_device);
      return isAmnet;
    },
  },
  mixins: [mixPreview, mixMobile, mixOutstream, mixYoutubePlayer],
  async mounted() {
    this.viewport();
    await this.$nextTick();
    const banner = document.querySelector('#main-container');
    const wrapper = document.querySelector('.main-wrapper');
    if (this.creative.preview_type === CONSTANT.ENUM_PREVIEW_TYPE.CONTENT) {
      wrapper.nextElementSibling.after(wrapper);
    } else if (
      this.creative.preview_type === CONSTANT.ENUM_PREVIEW_TYPE.INTERSTITIAL
    ) {
      wrapper.classList.add('mask');
      wrapper.onclick = (e) => {
        if (e.target == wrapper) this.close();
      };
      this.setStyle(banner, {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      });
    }
    let millisecond = this.creative.millisecond;
    if (
      this.creative.material_type === CONSTANT.MATERIAL_TYPE.HTML &&
      millisecond
    ) {
      let times = this.creative.times;
      if (times > 0) {
        times = times - 1;
      }
      let timer = setInterval(() => {
        if (times !== 0) {
          let iframe = document.querySelector('iframe');
          iframe.src = iframe.src;
        } else {
          clearInterval(timer);
        }
        if (times !== -1) {
          times = times - 1;
        }
      }, millisecond);
    }
    if (this.creative.vast_xml) {
      this.creative.vast_xml = this.removeTrackingEvent(this.creative.vast_xml);
      const target = document.getElementById('main-container');
      this.addPlayer(
        target,
        this.creative.video_width,
        this.creative.video_height
      );
      this.setStyle(this.video_div, this.position);
    } else if (this.creative.youtube_video_id) {
      let tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      let firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      const target = document.getElementById('main-container');
      window.onYouTubeIframeAPIReady = () => {
        const videoId = this.creative.youtube_video_id;
        const width = this.creative.video_width.toString();
        const height = this.creative.video_height.toString();
        this.player = this.addYtPlayer(target, videoId, width, height);
        this.video_div.removeAttribute('style');
        this.setStyle(this.video_div, this.position);
      };
    } else if (this.creative.facebook_video_url) {
      const fbStream = new FacebookPlayer(
        this.creative.facebook_video_url,
        this.creative.video_width,
        this.creative.video_height,
        this.creative.facebook_video_landing_page
      );
      const fbStreamEle = fbStream.init();
      this.setStyle(fbStreamEle, this.position);
      const fbTarget = document.getElementById('main-container');
      fbTarget.appendChild(fbStreamEle);
    }
  },
  methods: {
    messageHandler(e) {
      const frame = document.querySelector('.ucfad');

      switch (e.data.type) {
        case 'close':
          frame.style.display = 'none';
          break;
        case 'ready':
          this.setPlayerConfig();
          this.initialAd(this.creative.vast_xml);
          this.videoIO.observe(this.video_div);
          break;
        case 'Loaded':
          frame.style.display = 'block';
          this.onVideoPlay();
          this.removeVideoClickDiv();
          break;
        case 'Start':
          this.showToolBar();
          break;
        case 'error':
          this.$notify.error({
            title: 'Error',
            message: e.data.error,
            position: 'bottom-right',
            offset: 20,
          });
        default:
          break;
      }
    },
    openLandingPage() {
      window.open(this.creative.landing_page, '_blank');
    },
  },
};
</script>
<style lang="sass" scoped>
#main-container
  cursor: pointer
  margin: auto
  position: relative
  overflow: hidden
  .main-img
    max-width: 100%

.mask
  display: block
  position: fixed
  top: 0px
  left: 0px
  width: 100%
  height: 100%
  z-index: 2147483647
  background-image: url(https://s.yimg.com/ja/ap/tw/bwchou/fullpage_bg.png)
  .closebutton
    cursor: pointer
    position: absolute
    display: block
    width: 32px
    height: 32px
    background-color: white
    background-position: 0 0
    background-image: url('https://cdn.aralego.net/rich_media/assets/close_btn.png')
    z-index: 50000
    top: 5px
    right: 5px
    background-size: contain
    border-radius: 16px
</style>
